import { queryOptions, useQuery } from "@tanstack/react-query";

import { getAuth } from "~/providers/store/auth";

import { getMenus } from "../request";
import { menusKeys } from "../keys";
import { type FlexMenu, type FlexProduct } from "../types";

const menusQuery = (childId: string) =>
  queryOptions({
    queryKey: menusKeys.detail({ childId }),
    queryFn: () => {
      const { tillId } = getAuth();
      if (!tillId) {
        throw new Error("Till ID missing");
      }

      return getMenus({ childId, tillId });
    }
  });

export type UseGetMenusArgs = {
  childId: string;
};

export type FlexMenuWithProductsByCategory = FlexMenu & {
  productsByCategory: Record<
    string,
    {
      products: FlexProduct[];
      categoryName: string | null;
    }
  >;
};

export const useGetMenus = ({ childId }: UseGetMenusArgs) => {
  return useQuery({
    ...menusQuery(childId),
    select: (data) => {
      return {
        menus: data.menus.map((menu) => ({
          ...menu,
          productsByCategory: menu.products.reduce<
            FlexMenuWithProductsByCategory["productsByCategory"]
          >((acc, product) => {
            const { categoryId } = product;

            if (!acc[categoryId]) {
              acc[categoryId] = {
                products: [],
                categoryName:
                  menu.categories.find((c) => c.id === categoryId)?.name ?? null
              };
            }

            acc[categoryId].products.push(product);
            return acc;
          }, {})
        }))
      };
    }
  });
};
